import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const learningProgressApi = createApi({
  reducerPath: "learningProgressApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["LearningProgress"],
  endpoints: (builder) => ({
    // Get full progress
    getProgress: builder.query({
      query: () => "/learning-progress",
      providesTags: ["LearningProgress"],
    }),

    // Get stats
    getProgressStats: builder.query({
      query: () => "/learning-progress/stats",
      providesTags: ["LearningProgress"],
    }),

    // Get course progress
    getCourseProgress: builder.query({
      query: (courseId) => `/learning-progress/course/${courseId}`,
      providesTags: (result, error, courseId) => [
        { type: "LearningProgress", id: courseId },
      ],
    }),

    // Start course
    startCourse: builder.mutation({
      query: (data) => ({
        url: "/learning-progress/course/start",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["LearningProgress"],
    }),

    // Complete lesson
    completeLesson: builder.mutation({
      query: (data) => ({
        url: "/learning-progress/lesson/complete",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["LearningProgress"],
    }),

    // Complete course
    completeCourse: builder.mutation({
      query: (data) => ({
        url: "/learning-progress/course/complete",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["LearningProgress"],
    }),

    // Bookmark lesson
    bookmarkLesson: builder.mutation({
      query: (data) => ({
        url: "/learning-progress/bookmark",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["LearningProgress"],
    }),

    // Add note
    addNote: builder.mutation({
      query: (data) => ({
        url: "/learning-progress/note",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["LearningProgress"],
    }),

    // Sync progress
    syncProgress: builder.mutation({
      query: (data) => ({
        url: "/learning-progress/sync",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["LearningProgress"],
    }),
  }),
});

export const {
  useGetProgressQuery,
  useGetProgressStatsQuery,
  useGetCourseProgressQuery,
  useStartCourseMutation,
  useLessonCompleteMutation,
  useCompleteLessonMutation,
  useCompleteCourseMutation,
  useBookmarkLessonMutation,
  useAddNoteMutation,
  useSyncProgressMutation,
} = learningProgressApi;
